export function GlobovmsLogo({ compact = false, light = false, className = "" }) {
  const word = light ? "text-white" : "text-brand-ink";
  return (
    <span className={`inline-flex items-center gap-1 ${className}`}>
      <svg width={compact ? 30 : 34} height={compact ? 30 : 34} viewBox="0 0 32 32" aria-hidden="true">
        <rect x="4" y="7" width="24" height="21" rx="6" fill="#1EBDEF" />
        <rect x="11.5" y="3" width="9" height="6.5" rx="2" fill="#DB7327" />
        <circle cx="16" cy="5.6" r="1.15" fill="#fff" />
        <circle cx="16" cy="15.2" r="2.7" fill="#fff" />
        <path d="M10.2 24.8c1-3.4 3-5 5.8-5s4.8 1.6 5.8 5H10.2Z" fill="#fff" />
      </svg>
      {compact ? null : (
        <span className={`text-[19px] font-bold leading-none tracking-tight ${word}`}>
          globo<span className="-ml-px font-extrabold text-brand-orange">VMS</span>
        </span>
      )}
    </span>
  );
}
